import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import {toast} from 'react-toastify';
import axiosInstance from '../../axios'
import MultiCourse from '../Dropdowns/MultiCourse'
export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) {
  const {
    trainer_id,
    fname,
    photo,
    mname,  
    lname,
    mob_no,
    email,
    address,
    district,
    marital_status,
    qualification_certificate,
    experience_certificate,
    cv,
    pan_card,
    aadhar_card,
    pan_no,
    gender,
    course_ids,
    qualification,
    experience,
    dob,
     alt_mob_no,
    alt_email,
    aadhar_no,
    status,
    payment,
    trainer_code,
    username,
    password,
    tot_document,
  } = updateProductData;
  const[trainerCode,setTrainerCode]=useState(trainer_code)
  
  const [tphoto,setTPhoto]=useState(photo)
  const[tcv,setCV]=useState(cv)
  const[qual,setQual]=useState(qualification_certificate)
  const[exp,setExp]=useState(experience_certificate)
  const[pan,setPan]=useState(pan_card)
  const[adhar,setAdhar]=useState(aadhar_card)
  const formatDate= (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const[tgender,setTGender]=useState(gender)
  const[tot,setTot]=useState(tot_document||'')
  const [mStatus,setMStatus]=useState(marital_status)
  const [trainer, setTrainer] = useState({
    fname:fname,
    mname:mname,
    lname:lname,
    mo_no:mob_no,
    email:email,
    address:address,
    qualification:qualification,
    pan_no:pan_no,
    experience:experience,
    dob:formatDate(dob),
    district:district,
     alt_mob_no:alt_mob_no,
    alt_email:alt_email,
    aadhar_no:aadhar_no,
    status:status,
    payment:payment,
    username:username,
    password:password,
  });
const dont=true
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTrainer(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleFileChange=(e)=>{
    setTPhoto(e.target.files[0])
  }
  const [selectedCourses, setSelectedCourses] = useState(course_ids);

  const handleCourseChange = (newSelectedCourses) => {
    setSelectedCourses(newSelectedCourses);
  };

  const updateProduct=()=>{
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    const formData = new FormData();
    formData.append('fname', trainer.fname);
    formData.append('mname', trainer.mname);
    formData.append('lname', trainer.lname);
    formData.append('mob_no', trainer.mo_no);
    formData.append('email', trainer.email);
    formData.append('address', trainer.address);
    formData.append('district', trainer.district);
    formData.append('qualification', trainer.qualification);
    formData.append('experience', trainer.experience);
    formData.append('dob', formatDate(trainer.dob));
    formData.append('gender', tgender);
    formData.append('marital_status', mStatus);
    formData.append('status', trainer.status);
    formData.append('alt_mob_no', trainer.alt_mob_no);
    formData.append('payment', trainer.payment);
    formData.append('alt_email', trainer.alt_email);
    formData.append('aadhar_no', trainer.aadhar_no);
    formData.append('aadhar_card',adhar)

    formData.append('photo', tphoto);
    formData.append('course_id',selectedCourses); 
    formData.append('cv', cv)
    formData.append('pan_card', pan)
    formData.append('pan_no', trainer.pan_no);
    formData.append('qualification_certificate',qual)
    formData.append('experience_certificate',exp)
    formData.append('trainer_code',trainerCode)
    formData.append('username', trainer.username);
    formData.append('password',trainer.password)
    formData.append('tot_document',tot)
  
    axiosInstance.put(`/trainer/update/${trainer_id}`,formData)
    .then((res) => {
      toast.success('Trainer Updated')
      //updateProductData(res.data);
      updateModalSetting(false);
      handlePageUpdate()
     // updateModalSetting(false);
    })
    .catch((err)=>{
       console.log(err);
       toast.error('Error updating Trainer')
 
    })
    // Your code for updating product goes here
   
    // Close the modal after successful update
    setOpen(false);
  }
 
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left 
              shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Trainer
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        <div>
                            <label htmlFor="photo"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Profile Photo</label>
                            <label
        htmlFor="photo"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {photo?.name && photo.name.length > 8
            ? photo.name.substring(0, 8) + "..."
            : photo?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="photo"
        className="hidden"
        accept=".png, .jpeg, .jpg "
        required
        onChange={handleFileChange}
      />
                          </div>
                          <div>
                            <label 
                              htmlFor="trainerCode"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Trainer Code
                            </label>
                            <input 
                            type="text"
                            name="trainerCode"
                            id="trainerCode"
                            value={trainerCode}
                            onChange={e=>setTrainerCode(e.target.value)}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label 
                              htmlFor="fname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             First Name
                            </label>
                            <input 
                            type="text"
                            name="fname"
                            id="fname"
                            value={trainer.fname}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="mname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                          Middle Name
                            </label>
                            <input
                              type="text"
                              name="mname"
                              id="mname"
                              value={trainer.mname}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                           <div>
                            <label
                              for="lname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            Last Name
                            </label>
                            <input
                              type="text"
                              id="lname"
                              name="lname"
                              value={trainer.lname}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                          <div>
                            <label
                              for="qualifications"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Qualifications
                            </label>
                            <input
                              type="text"
                              name="qualification"
                              id="qualification"
                              value={trainer.qualification}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            
                            />
                          </div>
                          <div>
                            <label htmlFor="qual"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Qualification Certificate</label>
                            <label
        htmlFor="qual"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {qual?.name && qual.name.length > 8
            ? qual.name.substring(0, 8) + "..."
            : qual?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="qual"
        className="hidden"
        accept=".pdf"
        
         
        onChange={(e)=>setQual(e.target.files[0])}
      />
                          </div>
                          <div>
                          <label 
                          htmlFor="experience"
                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Experience
          </label>
          <input
            type="text"
            id="experience"
            name="experience"
            value={trainer.experience}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
                            </div>
                            <div>
                            <label htmlFor="exp"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Experience Certificate</label>
                            <label
        htmlFor="exp"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {exp?.name && exp.name.length > 8
            ? exp.name.substring(0, 8) + "..."
            : exp?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="exp"
        className="hidden"
        accept=".pdf"
        
         
        onChange={(e)=>setExp(e.target.files[0])}
      />
                          </div>
                            <div>
                              <label
                                htmlFor="district"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                District
                              </label>
                              <input
                                type="text"
                                id="district"
                                name="district"
                                value={trainer.district}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
                                </div>
                            <div>
                              <label
                                htmlFor="address"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Address
                              </label>
                              <input
                                type="text"
                                id="address"
                                name="address"
                                value={trainer.address}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            <div>
                            <label
                                htmlFor="dob"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date of Birth
                              </label>
                              <input
                               type="date"
                               id="dob"
                               name="dob"
                               value={trainer.dob}
                               onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               />
                            </div>
                            <div>
                            <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="gender">
        Gender
      </label>
        <select
          id="gender"
          onChange={(e)=>setTGender(e.target.value)}
          value={tgender}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value='' disabled>Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          
        </div>
      
                            </div>
                            <div >
      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="marital-status">
        Marital Status
      </label>
      <div >
        <select
          id="marital-status"
          onChange={(e)=>{
            setMStatus(e.target.value)
          }}
          value={mStatus}
      className="bg-gray-50 border border-gray-300 text-gratty-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="" disabled>Select your status</option>
          <option value="Unmarried">Unmarried</option>  
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>
      </div>
    </div>
                            <div>
                              <label htmlFor="email"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                               >
                                Email
                               </label>
                               <input type="email"
                              id="email"
                              name="email"
                              value={trainer.email}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            
                            <div>
                              <label htmlFor="mo_no"  
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Mobile No.
                                </label>
                              <input type="text"
                              id="mo_no"
                              name="mo_no"
                              value={trainer.mo_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="aadhar_no" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Aadhar No.
                             </label>
                              <input
                              type="text"
                              id="aadhar_no"
                              name="aadhar_no"
                              value={trainer.aadhar_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label htmlFor="adhar"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload Aadhar Card</label>
                            <label
        htmlFor="adhar"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {adhar?.name && adhar.name.length > 8
            ? adhar.name.substring(0, 8) + "..."
            : adhar?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="adhar"
        className="hidden"
        accept=".pdf"
        
         
        onChange={(e)=>setAdhar(e.target.files[0])}
      />
                          </div>
                            <div>
                              <label htmlFor="pan_no" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Pan No.</label>
                              <input
                              type="text"
                              id="pan_no" 
                              name="pan_no"
                              value={trainer.pan_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label htmlFor="pan"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload Pan Card</label>
                            <label
        htmlFor="pan"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {pan?.name && pan.name.length > 8
            ? pan.name.substring(0, 8) + "..."
            : pan?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="pan"
        className="hidden"
        accept=".pdf"
        
         
        onChange={e=>setPan(e.target.files[0])}
      />
                          </div>
                            <div>
                            <label
                              htmlFor="alt_mob_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Atlernet Mobile No.
                            </label>
                            <input 
                            type="text"
                            name="alt_mob_no"
                            id="alt_mob_no"
                            value={trainer.alt_mob_no}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="alt_email"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Alternate Email
                            </label>
                            <input 
                            type="text"
                            name="alt_email"
                            id="alt_email"
                            value={trainer.alt_email}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label htmlFor="tot"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >ToT Certificate<span className='text-red-500'> *</span></label>
                            <label
        htmlFor="tot"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tot?.name && tot.name.length > 8
            ? tot.name.substring(0, 8) + "..."
            : tot?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="tot"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setTot(e.target.files[0])}
      />
                          </div>
                         <div><label
                              htmlFor="status"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Status
                            </label>
                           <input type='text'
                            name="status"
                            id="status"
                            value={trainer.status}
                            onChange={handleInputChange}
                           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                            </div>

                            <div>
                            <label
                              htmlFor="payment"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Payment
                            </label>
                            <input 
                            type="number"
                            name="payment"
                            id="payment"
                            value={trainer.payment}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                            </div>
                            <div>
                            <label
                              htmlFor="username"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Username
                            </label>
                            <input 
                            type="text"
                            name="username"
                            id="username"
                            value={trainer.username}
                        
                            onChange={handleInputChange}
                              className="bg-gray-50 border hover:cursor-not-allowed border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                            </div>
                            <div>
                            <label
                              htmlFor="password"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Password
                            </label>
                            <input 
                            type="text"
                            name="password"
                            id="password"
                            value={trainer.password}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                            </div>
                            <div className='row-span-10 col-span-2'>
      <MultiCourse
        selectedCourses={selectedCourses}
        onChange={handleCourseChange}
        isDisabled={false}
      />
    
    </div>
                            <div>
                            <label htmlFor="tcv"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload CV</label>
                            <label
        htmlFor="tcv"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tcv?.name && tcv.name.length > 8
            ? tcv.name.substring(0, 8) + "..."
            : tcv?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="tcv"
        className="hidden"
        accept=".pdf"
        
         
        onChange={(e)=>setCV(e.target.files[0])}
      />
                          </div>
                           
                          
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
